import { GET_AREA_LIST, GET_AREA_LIST_FAIL, GET_AREA_LIST_SUCCESS } from '../types';

const initState = {
  areas: [],
  error: null,
  isLoading: false,
};

export default (state = initState, action) => {
  switch (action.type) {
    case GET_AREA_LIST: {
      return { ...state, isLoading: true };
    }

    case GET_AREA_LIST_SUCCESS: {
      const { payload } = action;

      return { ...state, isLoading: false, areas: payload, error: null };
    }

    case GET_AREA_LIST_FAIL: {
      const { payload } = action;

      return { ...state, isLoading: false, areas: [], error: payload };
    }

    default:
      return state;
  }
};
